import { CalculatorIcon, HardHatIcon, LightbulbIcon, SearchIcon, SettingsIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Fundamentals of Solar Energy & Photovoltaic Technology',
    summary: 'Solar principles, electrical basics, solar radiation, PV cells, modules, system types.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'Solar PV Components, Equipment & System Configurations',
    summary: 'Modules, inverters, batteries, charge controllers, protection, wiring, mounting, configurations.',
    icon: SettingsIcon,
  },
  {
    number: '3',
    title: 'Solar PV System Design, Sizing & Energy Calculations',
    summary: 'Load analysis, solar resources, array sizing, inverter sizing, battery sizing, 4 case studies.',
    icon: CalculatorIcon,
  },
  {
    number: '4',
    title: 'Solar PV Installation Principles, Commissioning & Electrical Safety',
    summary: 'Installation workflow, site assessment, mounting, electrical integration, safety, standards.',
    icon: HardHatIcon,
  },
  {
    number: '5',
    title: 'Solar PV Maintenance, Troubleshooting & Performance Analysis',
    summary: 'Maintenance, module issues, inverter problems, battery concerns, diagnostics, 10 case studies.',
    icon: SearchIcon,
  },
  {
    number: '6',
    title: 'Advanced Solar Applications, Energy Storage & PV Project Evaluation',
    summary: 'Residential, commercial, off-grid, hybrid systems, economics, project management, emerging tech.',
    icon: LightbulbIcon,
  },
];
